import React, { Component } from "react";
import { connect } from "react-redux";
import NavbarContainer from "../../Navbar/NavbarContainer";
import "./GettingStarted.scss";
import { Icon } from "semantic-ui-react";
import ExploreSearch from "./ExploreSearch";
import CreateQuery from "./CreateQuery";
import ExploreDashboard from "./ExploreDashboard";
import CreateAlerts from "./CreateAlerts";
import CreateReports from "./CreateReports";
import ConnectAccount from "./ConnectAccount";
import OwnedPageAnalytics from "./OwnedPageAnalytics";
import SMR from "./SMR";
import Trending from "./Trending";
import UpdateProfile from "./UpdateProfile";
import ManageUsers from "./ManageUsers";
import { ReactComponent as BlueTick } from "../../../assets/svg/blueTick.svg";
import { hideGettingStarted } from "../../../actions/globalAction";
import { ReactComponent as Close } from "../../../assets/svg/closeGS.svg";
//import {RouterContext} from "../../AppContainer/AppContainer"
import Collapsible from "react-collapsible";
import { ReactComponent as Chevron } from "../../../assets/svg/chevron.svg";
import Scrollbars from "react-custom-scrollbars";
import InteractiveHelp from "./InteractiveHelp";
import GettingStartedOverview from "./GettingStartedOverview";
import ListeningOverview from "./ListeningOverview";
import Notifications from "./Notifications";
import HelpAndSupport from "./HelpAndSupport";
import Collections from "./Collections";
import Downloads from "./Downloads";
import DataUsage from "./DataUsage";
import Settings from "./Settings";
import ResponseOverview from "./ResponseOverview";
import SMRInbox from "./SMRInbox";
import SMRSettings from "./SMRSettings";
import SMRAnalytics from "./SMRAnalytics";
import SMRCannedResponse from "./SMRCannedResponse";
import Integrations from "./Integrations";
import OPAOverview from "./OPAOverview";
import Fb from "./Fb";
import Ig from "./Ig";
import Twitter from "./Twitter";
import CompetitorInsights from "./CompetitorInsights";
import SMPOverview from "./PublishOverview";
import SMPDashboard from "./SMPDashboard";
import SMPSettings from "./SMPSettings";
import AssetLibrary from "./AssetLibrary";
import { getStartedCompleted, listeningCompleted, opaCompleted, responseCompleted, smpCompleted } from "./gettingStartedUtils";
import SMRFilters from "./SMRFilters";

class GettingStarted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            progress: 0,
            total_fields: 34,
            dropdownId: 1,
        };
    }

    componentDidMount() {
        let progress = 0;
        if (this.props.progressFields?.sections?.length) progress = this.props?.progressFields?.sections?.length;
        this.setState({ progress });

        // let total_fields = 5;
        // if (this.props.packageObj?.features?.listening_module_access.quota == 1) total_fields += 13;
        // if (this.props.packageObj?.features?.opa_module_access.quota == 1) total_fields += 5;
        // if (this.props.packageObj?.features?.smp_module_access.quota == 1) total_fields += 4;
        // if (this.props.packageObj?.features?.smr_module_access.quota == 1) total_fields += 7;
        let total_fields = 34;
        this.setState({ total_fields });

        if (getStartedCompleted.every((ele) => this.props.progressFields?.sections?.includes(ele))) {
            // if (this.props.packageObj?.features?.listening_module_access.quota) {
            //     if (!listeningCompleted.every((ele) => this.props.progressFields.sections.includes(ele))) {
            //         this.setState({ dropdownId: 2, step: 6 });
            //     } else if (this.props.packageObj?.features?.smp_module_access.quota) {
            //         if (!smpCompleted.every((ele) => this.props.progressFields.sections.includes(ele))) {
            //             this.setState({ dropdownId: 3, step: 19 });
            //         }
            //     }
            // }
            this.setActiveDropdown();
        }
    }
    setActiveDropdown = () => {
        if (
            // this.props.packageObj?.features?.listening_module_access.quota &&
            !listeningCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele))
        ) {
            this.setState({ dropdownId: 2, step: 6 });
            return;
        }

        if (
            // this.props.packageObj?.features?.smp_module_access.quota &&
            !smpCompleted.every((ele) => this.props.progressFields?.sections?.includes(ele))
        ) {
            this.setState({ dropdownId: 3, step: 19 });
            return;
        }
        if (
            // this.props.packageObj?.features?.smr_module_access.quota == 1 &&
            !responseCompleted.every((ele) => this.props.progressFields?.sections?.includes(ele))
        ) {
            this.setState({ dropdownId: 4, step: 23 });
            return;
        }
        if (
            // this.props.packageObj?.features?.opa_module_access.quota &&
            !opaCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele))
        ) {
            this.setState({ dropdownId: 5, step: 29 });
            return;
        }
    };
    componentWillUnmount() {}

    componentDidUpdate(prevProps) {}

    updateStep = (idx, field) => {
        let progress = this.state.progress;
        // if(!this.props.progressFields?.sections?.includes(field)) progress++;

        this.setState({
            step: idx,
            // progress
        });
    };

    renderPages = () => {
        switch (this.state.step) {
            case 1:
                // return <ExploreSearch total_fields={this.state.total_fields} />;
                return <GettingStartedOverview />;

            case 2:
                // return <CreateQuery total_fields={this.state.total_fields} />;
                return <UpdateProfile />;

            case 3:
                // return <ExploreDashboard total_fields={this.state.total_fields} />;
                return <InteractiveHelp />;

            case 4:
                // return <Trending total_fields={this.state.total_fields} />;
                return <Notifications />;

            case 5:
                return <HelpAndSupport />;
            // return <CreateReports total_fields={this.state.total_fields} />;
            case 6:
                return <ListeningOverview />;
            case 7:
                return <ExploreSearch total_fields={this.state.total_fields} />;

            case 8:
                return <CreateQuery total_fields={this.state.total_fields} />;

            case 9:
                return <ExploreDashboard total_fields={this.state.total_fields} />;

            case 10:
                return <Trending total_fields={this.state.total_fields} />;

            case 11:
                return <CreateReports total_fields={this.state.total_fields} />;
            case 12:
                return <CreateAlerts total_fields={this.state.total_fields} />;
            case 13:
                return <ConnectAccount total_fields={this.state.total_fields} />;

            case 14:
                return <ManageUsers total_fields={this.state.total_fields} />;
            case 15:
                return <Collections />;
            case 16:
                return <Downloads />;
            case 17:
                return <DataUsage />;
            case 18:
                return <Settings />;

            case 19:
                return <SMPOverview />;

            case 20:
                return <SMPDashboard />;

            case 21:
                return <SMPSettings />;

            case 22:
                return <AssetLibrary />;

            case 23:
                return <ResponseOverview />;

            case 24:
                return <SMRInbox />;

            case 25:
                return <SMRSettings />;

            case 26:
                return <SMRFilters />;

            case 27:
                return <SMRAnalytics />;

            case 28:
                return <SMRCannedResponse />;

            case 29:
                return <Integrations />;

            case 30:
                return <OPAOverview />;

            case 31:
                return <Fb />;

            case 32:
                return <Ig />;

            case 33:
                return <Twitter />;

            case 34:
                return <CompetitorInsights />;

            default:
                break;
            // return <GettingStartedOverview />;
        }
    };
    handleDropdownClick = (val) => {
        this.setState({
            dropdownId: val,
        });
    };
    calculatePercent = () => {
        // let total_fields = 11;
        // if (this.props.packageObj?.features?.owned_page_analytics.quota == 0) total_fields = 10;
        let percent = Math.round((this.props.progressFields?.sections?.length / this.state.total_fields) * 100);
        // if (percent == 100) this.props.hideGettingStarted();
        return <b>{`${percent}%`}</b>;
    };

    nextStep = () => {
        // if (this.state.step == 6 && this.props.packageObj?.features?.owned_page_analytics.quota == 0) {
        //     this.setState({ step: this.state.step + 2 });
        // } else {
        this.setState({ step: this.state.step + 1 });
        // }
    };

    backStep = () => {
        // if (this.state.step == 8 && this.props.packageObj?.features?.owned_page_analytics.quota == 0) {
        //     this.setState({ step: this.state.step - 2 });
        // } else {
        this.setState({ step: this.state.step - 1 });
        // }
    };
    routeClose = () => {
        // !this.props.route.from is undefined sometimes
        if (this.props.route.from == "/signin" || this.props.route.from == "" || !this.props.route.from) {
            window.location.href = "/home";
        } else {
            history.go(-1);
        }
    };

    gettingStartedArr = [
        {
            step: 1,
            updateContent: "getting_started_overview",
            heading: "Overview",
        },
        {
            step: 2,
            updateContent: "update_profile",
            heading: "Update Profile",
        },

        {
            step: 3,
            updateContent: "interactive_help",
            heading: "Interactive Help",
        },
        {
            step: 4,
            updateContent: "explore_notification",
            heading: "Notifications",
        },
        {
            step: 5,
            updateContent: "help_and_support",
            heading: "Help And Support",
        },
    ];

    listeningArr = [
        {
            step: 6,
            updateContent: "listening_overview",
            heading: "Overview",
        },
        {
            step: 7,
            updateContent: "explore_search",
            heading: "Search",
        },
        {
            step: 8,
            updateContent: "create_your_own_query",
            heading: "Query Builder",
        },
        {
            step: 9,
            updateContent: "explore_dashboards",
            heading: "Dashboard",
        },
        {
            step: 10,
            updateContent: "whats_trending",
            heading: "Trends",
        },
        {
            step: 11,
            updateContent: "create_reports",
            heading: "Reports",
        },
        {
            step: 12,
            updateContent: "create_alerts",
            heading: "Alerts",
        },
        {
            step: 13,
            updateContent: "connect_your_social_account",
            heading: "Social Tokens",
        },
        {
            step: 14,
            updateContent: "manage_users",
            heading: "User Management",
        },
        {
            step: 15,
            updateContent: "explore_collections",
            heading: "Collections",
        },
        {
            step: 16,
            updateContent: "explore_downloads",
            heading: "Downloads",
        },
        {
            step: 17,
            updateContent: "data_usage",
            heading: "Data Usage",
        },
        {
            step: 18,
            updateContent: "explore_settings",
            heading: "Settings",
        },
    ];

    responseArr = [
        {
            step: 23,
            updateContent: "response_overview",
            heading: "Overview",
        },
        {
            step: 24,
            updateContent: "smr_inbox",
            heading: "SMR Inbox",
        },
        {
            step: 25,
            updateContent: "smr_settings",
            heading: "SMR Settings",
        },
        // {
        //     step: 26,
        //     updateContent: "smr_filters",
        //     heading: "SMR Filters",
        // },
        {
            step: 27,
            updateContent: "smr_analytics",
            heading: "SMR Analytics",
        },

        // {
        //     step: 28,
        //     updateContent: "smr_canned_response",
        //     heading: "SMR Canned Response",
        // },
        // {
        //     step: 29,
        //     updateContent: "explore_integrations",
        //     heading: "Integrations",
        // },
    ];
    opaArr = [
        {
            step: 30,
            updateContent: "opa_overview",
            heading: "Overview",
        },
        {
            step: 31,
            updateContent: "explore_fb",
            heading: "Facebook Insights",
        },
        {
            step: 32,
            updateContent: "explore_ig",
            heading: "Instagram Insights",
        },

        {
            step: 33,
            updateContent: "explore_twitter",
            heading: "X Insights", //Changed Twitter name to X
        },
        {
            step: 34,
            updateContent: "competitor_analysis",
            heading: "Competitor Insights",
        },
    ];
    smpArr = [
        {
            step: 19,
            updateContent: "smp_overview",
            heading: "Overview",
        },
        {
            step: 20,
            updateContent: "smp_dashboard",
            heading: "Create New",
        },
        {
            step: 21,
            updateContent: "smp_settings",
            heading: "SMP Settings",
        },

        {
            step: 22,
            updateContent: "asset_library",
            heading: "Asset Library",
        },
    ];
    // isGettingStartedChecked
    isAllChecked = (id) => {
        switch (id) {
            case 1:
                return getStartedCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele));

            case 2:
                return listeningCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele));

            case 3:
                return smpCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele));

            case 4:
                return responseCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele));

            case 5:
                return opaCompleted.every((ele) => this.props?.progressFields?.sections?.includes(ele));

            default:
                return false;
        }
        // arr1.every((elem) => arr2.includes(elem));
    };

    shouldModuleExpand = (id, min, max) => {
        // if (this.state.dropdownId == id || (this.state.step >= min && this.state.step <= max)) return true;
        if (this.state.dropdownId == id) return true;
        else false;
    };

    render() {
        return (
            <div className="gs_section">
                <NavbarContainer
                    history={this.props.history}
                    location={this.props.location}
                    pageTitle="Getting Started"
                    // icon={HomeIcon}
                    // tourComponent={tourComponent}
                />
                <div className="gs_blocks">
                    <div className="gs_block1">
                        <div className="progress_circle">{this.calculatePercent()}</div>
                        <span className="label">Getting Started</span>
                        <Scrollbars autoHide className="getting__started__scrollbar">
                            <div className="menu_labels">
                                <Collapsible
                                    transitionTime={200}
                                    open={this.shouldModuleExpand(1, 1, 5)}
                                    className="getting__started__collapsible"
                                    trigger={
                                        <div className="getting__started__module__heading" onClick={() => this.handleDropdownClick(1)}>
                                            <span className="main__heading__container">
                                                {this.isAllChecked(1) ? <BlueTick className="checked_circle" /> : <div className="list_circle_unchecked"></div>}
                                                <span className="module__dropdown__heading">Platform Overview</span>
                                            </span>
                                            <Chevron className={`chevron__collapsible`} />
                                        </div>
                                    }>
                                    {this.gettingStartedArr.map((ele, idx) => (
                                        <>
                                            <span
                                                key={idx}
                                                className="menu_label"
                                                style={{ backgroundColor: this.state.step == ele.step ? "#F7F7F7" : "#fff" }}
                                                onClick={() => this.updateStep(ele.step, ele.updateContent)}>
                                                {this.props.progressFields.sections?.includes(ele.updateContent) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={this.state.step == ele.step ? "selected_circle" : "list_circle"}></div>
                                                )}
                                                <span className="heading">{ele.heading}</span>
                                                {/* <Icon
                                                name={"caret right"}
                                                className={this.state.step == ele.step ? "caret_right selected" : "caret_right"}
                                                size="mid"
                                            /> */}
                                            </span>
                                        </>
                                    ))}
                                </Collapsible>
                                {/* {this.props.packageObj?.features?.listening_module_access.quota == 1 && ( */}
                                <Collapsible
                                    transitionTime={200}
                                    open={this.shouldModuleExpand(2, 6, 18)}
                                    className="getting__started__collapsible"
                                    trigger={
                                        <div className="getting__started__module__heading" onClick={() => this.handleDropdownClick(2)}>
                                            <span className="main__heading__container">
                                                {this.isAllChecked(2) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={"list_circle_unchecked"}></div>
                                                )}
                                                <span className="module__dropdown__heading">Listening</span>
                                            </span>
                                            <Chevron className={`chevron__collapsible`} />
                                        </div>
                                    }>
                                    {this.listeningArr.map((ele, idx) => (
                                        <>
                                            <span
                                                key={idx}
                                                className="menu_label"
                                                style={{ backgroundColor: this.state.step == ele.step ? "#F7F7F7" : "#fff" }}
                                                onClick={() => this.updateStep(ele.step, ele.updateContent)}>
                                                {this.props.progressFields.sections?.includes(ele.updateContent) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={this.state.step == ele.step ? "selected_circle" : "list_circle"}></div>
                                                )}
                                                <span className="heading">{ele.heading}</span>
                                                {/* <Icon
                                                name={"caret right"}
                                                className={this.state.step == ele.step ? "caret_right selected" : "caret_right"}
                                                size="mid"
                                            /> */}
                                            </span>
                                        </>
                                    ))}
                                </Collapsible>
                                {/* )} */}
                                {/* {this.props.packageObj?.features?.smp_module_access.quota == 1 && ( */}
                                <Collapsible
                                    transitionTime={200}
                                    open={this.shouldModuleExpand(3, 19, 22)}
                                    className="getting__started__collapsible"
                                    trigger={
                                        <div className="getting__started__module__heading" onClick={() => this.handleDropdownClick(3)}>
                                            <span className="main__heading__container">
                                                {this.isAllChecked(3) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={"list_circle_unchecked"}></div>
                                                )}
                                                <span className="module__dropdown__heading">{"Publishing (Beta)"}</span>
                                            </span>
                                            <Chevron className={`chevron__collapsible`} />
                                        </div>
                                    }>
                                    {this.smpArr.map((ele, idx) => (
                                        <>
                                            <span
                                                key={idx}
                                                className="menu_label"
                                                style={{ backgroundColor: this.state.step == ele.step ? "#F7F7F7" : "#fff" }}
                                                onClick={() => this.updateStep(ele.step, ele.updateContent)}>
                                                {this.props.progressFields.sections?.includes(ele.updateContent) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={this.state.step == ele.step ? "selected_circle" : "list_circle"}></div>
                                                )}
                                                <span className="heading">{ele.heading}</span>
                                                {/* <Icon
                                                name={"caret right"}
                                                className={this.state.step == ele.step ? "caret_right selected" : "caret_right"}
                                                size="mid"
                                            /> */}
                                            </span>
                                        </>
                                    ))}
                                </Collapsible>
                                {/* )} */}
                                {/* {this.props.packageObj?.features?.smr_module_access.quota == 1 && ( */}
                                <Collapsible
                                    transitionTime={200}
                                    open={this.shouldModuleExpand(4, 23, 28)}
                                    className="getting__started__collapsible"
                                    trigger={
                                        <div className="getting__started__module__heading" onClick={() => this.handleDropdownClick(4)}>
                                            <span className="main__heading__container">
                                                {this.isAllChecked(4) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={"list_circle_unchecked"}></div>
                                                )}

                                                <span className="module__dropdown__heading">Response</span>
                                            </span>
                                            <Chevron className={`chevron__collapsible`} />
                                        </div>
                                    }>
                                    {this.responseArr.map((ele, idx) => (
                                        <>
                                            <span
                                                key={idx}
                                                className="menu_label"
                                                style={{ backgroundColor: this.state.step == ele.step ? "#F7F7F7" : "#fff" }}
                                                onClick={() => this.updateStep(ele.step, ele.updateContent)}>
                                                {this.props.progressFields.sections?.includes(ele.updateContent) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={this.state.step == ele.step ? "selected_circle" : "list_circle"}></div>
                                                )}
                                                <span className="heading">{ele.heading}</span>
                                                {/* <Icon
>>>>>>> 4a17ef2b0b14ba358415a000c1857438f189058b
                                                name={"caret right"}
                                                className={this.state.step == ele.step ? "caret_right selected" : "caret_right"}
                                                size="mid"
                                            /> */}
                                            </span>
                                        </>
                                    ))}
                                </Collapsible>
                                {/* )} */}
                                {/* {this.props.packageObj?.features?.opa_module_access.quota == 1 && ( */}
                                <Collapsible
                                    transitionTime={200}
                                    open={this.shouldModuleExpand(5, 29, 33)}
                                    className="getting__started__collapsible"
                                    trigger={
                                        <div className="getting__started__module__heading" onClick={() => this.handleDropdownClick(5)}>
                                            <span className="main__heading__container">
                                                {this.isAllChecked(5) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={"list_circle_unchecked"}></div>
                                                )}
                                                <span className="module__dropdown__heading">{"Page Analytics (Beta)"}</span>
                                            </span>
                                            <Chevron className={`chevron__collapsible`} />
                                        </div>
                                    }>
                                    {this.opaArr.map((ele, idx) => (
                                        <>
                                            <span
                                                key={idx}
                                                className="menu_label"
                                                style={{ backgroundColor: this.state.step == ele.step ? "#F7F7F7" : "#fff" }}
                                                onClick={() => this.updateStep(ele.step, ele.updateContent)}>
                                                {this.props.progressFields.sections?.includes(ele.updateContent) ? (
                                                    <BlueTick className="checked_circle" />
                                                ) : (
                                                    <div className={this.state.step == ele.step ? "selected_circle" : "list_circle"}></div>
                                                )}
                                                <span className="heading">{ele.heading}</span>
                                                {/* <Icon
                                                name={"caret right"}
                                                className={this.state.step == ele.step ? "caret_right selected" : "caret_right"}
                                                size="mid"
                                            /> */}
                                            </span>
                                        </>
                                    ))}
                                </Collapsible>
                                {/* )} */}

                                {/* <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 1 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(1, "explore_search")}>
                                {this.props.progressFields.sections?.includes("explore_search") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 1 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading"> Search</span>
                                <Icon name={"caret right"} className={this.state.step == 1 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 2 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(2, "create_your_own_query")}>
                                {this.props.progressFields.sections?.includes("create_your_own_query") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 2 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Create your own Query</span>
                                <Icon name={"caret right"} className={this.state.step == 2 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 3 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(3, "explore_dashboards")}>
                                {this.props.progressFields.sections?.includes("explore_dashboards") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 3 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Dashboards</span>
                                <Icon name={"caret right"} className={this.state.step == 3 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 4 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(4, "explore_dashboards")}>
                                {this.props.progressFields.sections?.includes("whats_trending") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 4 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">{`What's Trending`}</span>
                                <Icon name={"caret right"} className={this.state.step == 4 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 5 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(5, "create_reports")}>
                                {this.props.progressFields.sections?.includes("create_reports") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 5 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Create Reports</span>
                                <Icon name={"caret right"} className={this.state.step == 5 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 6 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(6, "create_alerts")}>
                                {this.props.progressFields.sections?.includes("create_alerts") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 6 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Create Alerts</span>
                                <Icon name={"caret right"} className={this.state.step == 6 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            {this.props.packageObj?.features?.owned_page_analytics.quota > 0 && (
                                <span
                                    className="menu_label"
                                    style={{ backgroundColor: this.state.step == 7 ? "#F7F7F7" : "#fff" }}
                                    onClick={() => this.updateStep(7, "owned_page_analytics")}>
                                    {this.props.progressFields.sections?.includes("owned_page_analytics") ? (
                                        <BlueTick className="checked_circle" />
                                    ) : (
                                        <div className={this.state.step == 7 ? "selected_circle" : "list_circle"}></div>
                                    )}

                                    <span className="heading">Owned Page Analytics</span>
                                    <Icon name={"caret right"} className={this.state.step == 7 ? "caret_right selected" : "caret_right"} size="mid" />
                                </span>
                            )}

                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 8 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(8, "social_media_response")}>
                                {this.props.progressFields.sections?.includes("social_media_response") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 8 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Social Media Response</span>
                                <Icon name={"caret right"} className={this.state.step == 8 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 9 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(9, "connect_your_social_account")}>
                                {this.props.progressFields.sections?.includes("connect_your_social_account") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 9 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Connect your social account</span>
                                <Icon name={"caret right"} className={this.state.step == 9 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 10 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(10, "manage_users")}>
                                {this.props.progressFields.sections?.includes("manage_users") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 10 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Manage Users</span>
                                <Icon name={"caret right"} className={this.state.step == 10 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                            <span
                                className="menu_label"
                                style={{ backgroundColor: this.state.step == 11 ? "#F7F7F7" : "#fff" }}
                                onClick={() => this.updateStep(11, "update_profile")}>
                                {this.props.progressFields.sections?.includes("update_profile") ? (
                                    <BlueTick className="checked_circle" />
                                ) : (
                                    <div className={this.state.step == 11 ? "selected_circle" : "list_circle"}></div>
                                )}
                                <span className="heading">Update Profile</span>
                                <Icon name={"caret right"} className={this.state.step == 11 ? "caret_right selected" : "caret_right"} size="mid" />
                            </span>
                        */}
                            </div>
                        </Scrollbars>
                    </div>
                    <div className="gs_block2">
                        <Close className="close_icon" onClick={() => this.routeClose()} />
                        <div>{this.renderPages()}</div>
                        <div className="gs_footer">
                            {/* {![1, 6, 19, 23, 29].includes(this.state.step) && ( */}
                            <button
                                className={`previous_btn ${[1, 6, 19, 23, 30].includes(this.state.step) && "hide_button_particular_step"}`}
                                // style={{ color: "#268af6" }}
                                onClick={() => this.backStep()}>
                                {" "}
                                {/* <Icon name="arrow left" color="#268af6" /> */}
                                Previous{" "}
                            </button>
                            {/* )} */}
                            {
                                // this.state.step !== 5
                                // ![5, 18, 22, 28, 33].includes(this.state.step) && (
                                <button
                                    className={`next_btn ${[5, 18, 22, 29, 34].includes(this.state.step) && "hide_button_particular_step"} `}
                                    onClick={() => this.nextStep()}>
                                    {" "}
                                    Next{" "}
                                </button>
                                // )
                            }
                            {/* {this.state.step == 11 && (
                                <button className="hide_btn" onClick={() => this.props.hideGettingStarted()}>
                                    {" "}
                                    Hide Getting Started
                                </button>
                            )} */}
                            {/* {this.state.step == 11 && (
                                <button className="finish_btn" onClick={() => this.setState({ step: 1 })}>
                                    {" "}
                                    Finish{" "}
                                </button>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        progressFields: state.globalReducer.progressFields,
        packageObj: state.globalReducer.packageObj,
        route: state.globalReducer.route,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideGettingStarted: () => dispatch(hideGettingStarted()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GettingStarted);
